import type { MeetingBasedRunner } from '@ps/isp-web-services-types';
import { Translation } from '@ps/web-shared-components';
import classNames from 'clsx';
import React from 'react';

import { Odds } from '@swf/sports/components/Odds/Odds';

import {
  TXTWCL_Age_3,
  TXTWCL_Days_Since_Last_Run,
  TXTWCL_Gear,
  TXTWCL_Official_Rating,
  TXTWCL_Price_History,
  TXTWCL_Weight
} from './HorseDetails.messages.json';
import styles from './HorseDetails.scss';

interface Props {
  runner: MeetingBasedRunner;
  isDetailsExpanded: boolean;
}

const HorseDetails: React.FC<Props> = ({ runner, isDetailsExpanded }) => {
  const { horse, rating, daysOff, details } = runner;
  const weight = details?.weight;
  const equipmentDescription = details?.equipmentDescription;

  return (
    <dl
      id={`details-dropdown-${runner.selectionId}`}
      className={classNames(styles.details, {
        [styles.detailsExpanded]: isDetailsExpanded
      })}
    >
      <dt className={styles.detailsItemHeading}>
        <Translation {...TXTWCL_Price_History} />:
      </dt>
      <dd data-testid="price-history">
        {runner.previousWinRunnerOdds.length
          ? runner.previousWinRunnerOdds.map((odds, i) => (
              <Odds key={`price-history-${i}`} {...odds} />
            ))
          : '-'}
      </dd>
      <dt className={styles.detailsItemHeading}>
        <Translation {...TXTWCL_Age_3} />:
      </dt>
      <dd data-testid="age">{horse && horse.age ? horse.age : '-'}</dd>
      <dt className={styles.detailsItemHeading}>
        <Translation {...TXTWCL_Weight} />:
      </dt>
      <dd data-testid="weight">{weight && weight.stones ? weight.stones : '-'}</dd>
      <dt className={styles.detailsItemHeading}>
        <Translation {...TXTWCL_Gear} />:
      </dt>
      <dd data-testid="gear">{equipmentDescription ?? '-'}</dd>
      <dt className={styles.detailsItemHeading}>
        <Translation {...TXTWCL_Official_Rating} />:
      </dt>
      <dd data-testid="official-rating">{rating ?? '-'}</dd>
      <dt className={styles.detailsItemHeading}>
        <Translation {...TXTWCL_Days_Since_Last_Run} />:
      </dt>
      <dd data-testid="last-run">{daysOff ?? '-'}</dd>
    </dl>
  );
};

export default HorseDetails;
